export * from './dto.interface';
export * from './medrecord-response.interface';
